import { Link } from "react-router-dom";
import { Settings } from "lucide-react";
import type { User } from "@lumen/shared";
import { t } from "../../i18n";
import { OrganizationSwitcher } from "../organization/OrganizationSwitcher";
import { PwaInstallButton } from "../PwaInstallButton";

export function SidebarFooter({
  user,
  view,
  setOpen,
}: {
  user: User;
  view: "chat" | "project";
  setOpen: (value: boolean) => void;
}) {
  const rememberView = (nextView: "chat" | "project") => {
    try {
      window.localStorage.setItem("lumen:last-view", nextView);
    } catch {
      // Local storage can be unavailable in private or restricted browsing.
    }
  };
  return (
    <>
      <div className="mb-2 shrink-0 border-t border-stone-200 pt-3 dark:border-white/10">
        <OrganizationSwitcher supportAccess={user.supportAccess} />
        <PwaInstallButton />
        <div className="mt-2 grid grid-cols-2 gap-1 rounded-xl bg-stone-200/70 p-1 text-sm dark:bg-white/5">
          <Link
            to="/"
            onClick={() => rememberView("chat")}
            className={`rounded-lg px-3 py-2 text-center ${view === "chat" ? "font-semibold text-lumen-700 dark:text-lumen-300" : "text-stone-500 hover:text-lumen-700 dark:text-stone-400 dark:hover:text-lumen-300"}`}
          >
            {t("Chat")}
          </Link>
          <Link
            to="/projects"
            onClick={() => rememberView("project")}
            className={`rounded-lg px-3 py-2 text-center ${view === "project" ? "font-semibold text-lumen-700 dark:text-lumen-300" : "text-stone-500 hover:text-lumen-700 dark:text-stone-400 dark:hover:text-lumen-300"}`}
          >
            {t("Project view")}
          </Link>
        </div>
      </div>
      <div
        data-testid="sidebar-profile"
        className="flex shrink-0 items-center gap-3 rounded-xl p-2 hover:bg-white/70 dark:hover:bg-white/5"
      >
        <div className="grid size-8 place-items-center overflow-hidden rounded-full bg-lumen-100 font-bold text-lumen-800 dark:bg-lumen-900/50 dark:text-lumen-200">
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt=""
              className="size-full object-cover"
            />
          ) : (
            user.name[0]
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-sm font-semibold">{user.name}</div>
          <div className="truncate text-xs text-stone-400">{user.email}</div>
        </div>
        <Link
          to="/settings/profile"
          onClick={() => setOpen(false)}
          className="button shrink-0 p-2"
          title={t("Settings")}
          aria-label={t("Settings")}
        >
          <Settings size={17} />
        </Link>
      </div>
    </>
  );
}
